const exportNs = {
  exportCsv: "Export CSV",
  exporting: "Exporting...",
  exportSuccess: "File downloaded successfully",
  exportError: "Export failed",
  exportEmpty: "No data to export",
  noData: "No data to export",
} as const;
export default exportNs;
